import React from "react";

export default function MiseEnEau() {
  return (
    <div className="bg-white rounded-xl shadow p-6 text-gray-400 text-sm">
      <p className="text-gray-700 font-semibold mb-1">MiseEnEau</p>
      <p>En cours de développement.</p>
    </div>
  );
}
